/* JW_NL_JS_V1_BEGIN */
if (document.documentElement.lang === 'nl') {
/* jw-newsletter.js — Interception des formulaires newsletter (footer + popup).
   Shopify traite POST /contact (création du client taggé newsletter) mais le thème
   Craft n'a pas de template contact → page 404 après soumission.
   On intercepte : fetch POST (inscription réelle côté serveur) + affichage du
   code CODE10 côté client, sans navigation.
*/
(function () {
  function intercept() {
    var forms = document.querySelectorAll('form.newsletter-form, form.jw-popup__form');
    forms.forEach(function (form) {
      if (form.dataset.jwIntercepted) return;
      form.dataset.jwIntercepted = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('button[type=submit], .newsletter-form__button');
        if (submitBtn) { submitBtn.disabled = true; }
        fetch(form.action || '/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString(),
          redirect: 'follow'
        }).then(function (r) { return r.text(); }).then(function () {
          showSuccess(form);
        }).catch(function () {
          if (submitBtn) submitBtn.disabled = false;
          form.submit(); // fallback natif
        });
      });
    });
  }
  function showSuccess(form) {
    var wrapper = form.closest('.jw-popup__panel, .footer-block__newsletter, .newsletter__wrapper, .footer');
    var popup = form.closest('.jw-popup');
    if (popup) {
      var success = popup.querySelector('.jw-popup__success');
      if (success) {
        success.innerHTML = '<p>Bedankt! Uw welkomstcode:</p><p class="jw-popup__code">CODE10</p><p>Vul deze in bij het afrekenen. De code is geldig voor uw eerste bestelling.</p>';
        success.style.display = 'block';
      }
      var txt = popup.querySelector('.jw-popup__text');
      if (txt) txt.style.display = 'none';
      form.style.display = 'none';
      return;
    }
    var el = document.createElement('p');
    el.style.margin = '1rem 0 0';
    el.style.fontSize = '.95rem';
    el.style.color = '#2c2a27';
    el.innerHTML = 'Bedankt! Uw welkomstcode: <strong style="color:#b5654c;letter-spacing:.08em;">CODE10</strong> — geldig voor uw eerste bestelling.';
    if (wrapper) { form.replaceWith(el); }
    else { form.insertAdjacentElement('afterend', el); form.style.display = 'none'; }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', intercept);
  } else {
    intercept();
  }
})();

} else { /* JW_NL_JS_FR_ORIGINAL_V1 */
/* jw-newsletter.js — Interception des formulaires newsletter (footer + popup).
   Shopify traite POST /contact (création du client taggé newsletter) mais le thème
   Craft n'a pas de template contact → page 404 après soumission.
   On intercepte : fetch POST (inscription réelle côté serveur) + affichage du
   code CODE10 côté client, sans navigation.
*/
(function () {
  function intercept() {
    var forms = document.querySelectorAll('form.newsletter-form, form.jw-popup__form');
    forms.forEach(function (form) {
      if (form.dataset.jwIntercepted) return;
      form.dataset.jwIntercepted = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('button[type=submit], .newsletter-form__button');
        if (submitBtn) { submitBtn.disabled = true; }
        fetch(form.action || '/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString(),
          redirect: 'follow'
        }).then(function (r) { return r.text(); }).then(function () {
          showSuccess(form);
        }).catch(function () {
          if (submitBtn) submitBtn.disabled = false;
          form.submit(); // fallback natif
        });
      });
    });
  }
  function showSuccess(form) {
    var wrapper = form.closest('.jw-popup__panel, .footer-block__newsletter, .newsletter__wrapper, .footer');
    var popup = form.closest('.jw-popup');
    if (popup) {
      var success = popup.querySelector('.jw-popup__success');
      if (success) {
        success.innerHTML = '<p>Merci ! Votre code de bienvenue :</p><p class="jw-popup__code">CODE10</p><p>Saisissez-le au moment du paiement. Il est valable sur votre première commande.</p>';
        success.style.display = 'block';
      }
      var txt = popup.querySelector('.jw-popup__text');
      if (txt) txt.style.display = 'none';
      form.style.display = 'none';
      return;
    }
    var el = document.createElement('p');
    el.style.margin = '1rem 0 0';
    el.style.fontSize = '.95rem';
    el.style.color = '#2c2a27';
    el.innerHTML = 'Merci ! Votre code de bienvenue : <strong style="color:#b5654c;letter-spacing:.08em;">CODE10</strong> — valable sur votre première commande.';
    if (wrapper) { form.replaceWith(el); }
    else { form.insertAdjacentElement('afterend', el); form.style.display = 'none'; }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', intercept);
  } else {
    intercept();
  }
})();

}
/* JW_NL_JS_V1_END */